import {generatePath, Link} from 'react-router-dom';
// import {generateCreatePath, generateEditPath, generateShowPath} from './ra-helpers';
// import {useDelete, useResourceContext, useSaveContext, useUpdate} from 'ra-core';
import {SquareChartGantt, WorkflowIcon} from 'lucide-react';
import {Button} from '@/shadcn_components/ui/button';
import {CanAccess, useCan, useResourceParams} from '@refinedev/core';
import {EditButtonProps} from '@/components/refinedev/action_buttons';

export const EditButtonWorkflow = (props: EditButtonProps) => {
  const {resource, id} = useResourceParams(props);
  if (!resource?.name || !id) throw 'Resource and id must be specified for Edit button';
  // const {forceCan} = props;
  const {data: canUpdateProject} = useCan({
    resource: resource.name,
    action: 'update',
    params: {...props.canParams, id},
  });
  // const {data: canAccessTaskList} = useCan({
  //   resource: 'tasks',
  //   action: 'list',
  // });

  if (canUpdateProject?.can === false) return null;

  // if (
  //   (canUpdateProject?.can === false &&
  //     // || canAccessTaskList?.can === false
  //     forceCan === undefined) ||
  //   forceCan === false
  // )
  //   return null;

  return (
    <Link to={generatePath('/' + resource.name + '/:id/editwf', {id})}>
      <Button
        variant="ghost"
        size="icon"
        className="px-1 py-1 rounded-md text-blue-600 hover:bg-blue-50 hover:border-blue-600 hover:border hover:text-blue-600"
        title="Chỉnh sửa lưu đồ">
        <WorkflowIcon className="w-4 h-4" />
      </Button>
    </Link>
  );
};

export const ProjectTasksEditButton = (props: EditButtonProps) => {
  const {resource, id} = useResourceParams(props);
  if (!resource?.name || !id) throw 'Resource and id must be specified for Edit button';
  return (
    <Link to={generatePath('/' + resource.name + '/:id/edit-tasks', {id})}>
      <Button
        variant="ghost"
        size="icon"
        className="px-1 py-1 rounded-md text-blue-600 hover:bg-blue-50 hover:border-blue-600 hover:border hover:text-blue-600"
        {...props}>
        <SquareChartGantt className="w-4 h-4" />
      </Button>
    </Link>
  );
};
